import { render, staticRenderFns } from "./IncludePallets.vue?vue&type=template&id=b34805cc&"
import script from "./IncludePallets.vue?vue&type=script&lang=js&"
export * from "./IncludePallets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports